var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container", staticStyle: { background: "#f4f5f7" } },
    [
      _c("div", { staticStyle: { background: "#f4f5f7" } }, [
        _c("div", { staticClass: "flex-align steps flex-spacebetween" }, [
          _c("div", { staticClass: "steps-left" }, [
            _c("span", [
              _vm._v(
                _vm._s(_vm.detail.customerName) +
                  " " +
                  _vm._s(_vm.$t("billingPage.MyDepositPage.title"))
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "steps-right" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.toPrepay } },
                [_vm._v(_vm._s(_vm.$t("billingPage.MyDepositPage.Prepay")))]
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "flex-align max-box flex-spacebetween flex-wrap" },
          [
            _c("div", { staticClass: "max-box-left" }, [
              _c("div", { staticClass: "flex-box" }, [
                _c("div", { staticClass: "flex-box-item" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("billingPage.MyDepositPage.Balance"))),
                  ]),
                  _c("div", { staticClass: "flex-box-item-bet" }, [
                    _c(
                      "div",
                      {
                        style: "color:" + (_vm.detail.balance < 0 ? "red" : ""),
                      },
                      [_vm._v(_vm._s(_vm.formatPrice(_vm.detail.balance)))]
                    ),
                    _c("span", [_vm._v("=")]),
                  ]),
                ]),
                _c("div", { staticClass: "flex-box-item" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("billingPage.MyDepositPage.Available"))
                    ),
                  ]),
                  _c("div", { staticClass: "flex-box-item-bet" }, [
                    _c(
                      "div",
                      {
                        style:
                          "color:" + (_vm.detail.available < 0 ? "red" : ""),
                      },
                      [_vm._v(_vm._s(_vm.formatPrice(_vm.detail.available)))]
                    ),
                    _c("span", [_vm._v("+")]),
                  ]),
                ]),
                _c("div", { staticClass: "flex-box-item" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("billingPage.MyDepositPage.Credit"))),
                  ]),
                  _c("div", { staticClass: "flex-box-item-bet" }, [
                    _c(
                      "div",
                      {
                        style: "color:" + (_vm.detail.credit < 0 ? "red" : ""),
                      },
                      [_vm._v(_vm._s(_vm.formatPrice(_vm.detail.credit)))]
                    ),
                    _c("span", [_vm._v("+")]),
                  ]),
                ]),
                _c("div", { staticClass: "flex-box-item" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("billingPage.MyDepositPage.Unpaid"))),
                  ]),
                  _c(
                    "div",
                    { style: "color:" + (_vm.detail.unpaid < 0 ? "red" : "") },
                    [_vm._v(_vm._s(_vm.formatPrice(_vm.detail.unpaid)))]
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "max-box-right" }, [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("billingPage.MyDepositPage.SecurityBond"))
                ),
              ]),
              _c(
                "div",
                {
                  style: "color:" + (_vm.detail.securityBond < 0 ? "red" : ""),
                },
                [_vm._v(_vm._s(_vm.formatPrice(_vm.detail.securityBond)))]
              ),
            ]),
            _c("div", { staticClass: "max-box-tip" }, [
              _c("div", [
                _vm._v(_vm._s(_vm.$t("billingPage.MyDepositPage.tip1"))),
              ]),
              _c("div", [
                _vm._v(_vm._s(_vm.$t("billingPage.MyDepositPage.tip2"))),
              ]),
            ]),
          ]
        ),
      ]),
      _c(
        "div",
        {
          staticStyle: {
            background: "#fff",
            padding: "10px 20px",
            border: "1px solid #ddd",
            "border-radius": "10px",
          },
        },
        [
          _c(
            "div",
            { staticStyle: { padding: "10px 0px", "font-size": "x-large" } },
            [_vm._v(_vm._s(_vm.$t("billingPage.BillingTransactions")))]
          ),
          _c("BjPage", {
            ref: "BjPage",
            attrs: {
              "label-width": "80px",
              "query-params": _vm.queryParams,
              "col-span": _vm.colSpan,
              "get-action": _vm.queryApi,
              serial: _vm.serial,
              "before-reset-search": _vm.beforeResetSearch,
              selection: _vm.selection,
            },
            on: {
              handleSelectionChange: _vm.handleSelectionChange,
              showSetting: _vm.SortableTable.show,
              "header-dragend": _vm.SortableTable.handleHeaderDragend,
              "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
            },
            scopedSlots: _vm._u([
              {
                key: "baseForm",
                fn: function () {
                  return [
                    _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("billingPage.source"),
                              prop: "source",
                            },
                          },
                          [
                            _c("BjSelectLov", {
                              attrs: {
                                "option-list": _vm.sourceList,
                                placeholder: _vm.$t("billingPage.source"),
                              },
                              model: {
                                value: _vm.queryParams.source,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "source", $$v)
                                },
                                expression: "queryParams.source",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("billingPage.gmtCreate"),
                              prop: "updateTime",
                            },
                          },
                          [
                            _c("BjDateRangePicker", {
                              attrs: {
                                placeholder: _vm.$t("billingPage.gmtCreate"),
                              },
                              model: {
                                value: _vm.queryParamsTransTime,
                                callback: function ($$v) {
                                  _vm.queryParamsTransTime = $$v
                                },
                                expression: "queryParamsTransTime",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "tableOperation",
                fn: function () {
                  return [
                    _c(
                      "el-col",
                      [
                        _c("BjFrontendExport", {
                          staticClass: "main-btn",
                          attrs: {
                            type: "primary",
                            "label-list": _vm.labelList,
                            rows: _vm.selectedRows,
                            "file-name": "Deposit.csv",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "tableColumn",
                fn: function () {
                  return [
                    _vm._l(_vm.dropCols, function (col, index) {
                      return [
                        col.prop !== "bjTableAction"
                          ? _c("el-table-column", {
                              key:
                                "col_" +
                                index +
                                "_" +
                                col.prop +
                                "_" +
                                (col.width || "auto"),
                              attrs: {
                                prop: col.prop,
                                label: col.label,
                                width: col.width || "auto",
                                fixed: col.fixed || false,
                                align: "center",
                                "class-name": "item",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        false
                                          ? void 0
                                          : _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("timeFilters")(
                                                    scope.row[col.prop],
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              ),
                                            ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            })
                          : _vm._e(),
                        col.prop === "bjTableAction"
                          ? _c("el-table-column", {
                              key:
                                "col_" +
                                index +
                                "_" +
                                col.prop +
                                "_" +
                                (col.width || "auto"),
                              attrs: {
                                prop: col.prop,
                                label: col.label,
                                width: col.width || "auto",
                                fixed: col.fixed || "right",
                                align: "center",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "edit-btn",
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onView(props.row)
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("viewText")))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            })
                          : _vm._e(),
                      ]
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }